/**
 * Órgão que avança por inércia até encostar numa parede (caixa torácica, crânio, parede abdominal).
 * Até a parede ele só desloca; depois dela o avanço excedente vira achatamento na direção do
 * movimento, com alargamento lateral. Ilustrativo: não calcula tensão nem diagnostica lesão.
 */
export interface ColisaoOrgao {
  /** quanto o órgão se desloca antes de tocar a parede, em metros */
  deslocamento: number
  /** fração de achatamento na direção do avanço (0 = sem contato) */
  achatamento: number
  /** escala lateral que acompanha o achatamento */
  alargamento: number
  /** avanço que não coube no deslocamento livre: tração das fixações */
  excesso: number
}

const limitar = (v: number, min: number, max: number) => Math.max(min, Math.min(max, Number.isFinite(v) ? v : min))

export function colidirOrgao(avanco: number, folga: number, meiaProfundidade: number, achatamentoMax = 0.4): ColisaoOrgao {
  const total = Math.max(0, Number.isFinite(avanco) ? avanco : 0)
  const livre = Math.max(0, folga)
  const deslocamento = Math.min(total, livre)
  const excesso = total - deslocamento
  const achatamento = limitar(excesso / Math.max(1e-6, meiaProfundidade), 0, achatamentoMax)
  return { deslocamento, achatamento, alargamento: 1 + achatamento * 0.3, excesso }
}
